<template>
  <div class="products-container">
    <nav-bar></nav-bar>
    <div class="container second-container">
      <div class="columns is-vcentered custom-vertical-space">
        <div class="column is-12"></div>
      </div>
      <div class="columns">
        <div class="column is-10-fullhd is-offset-1-fullhd products-title">
          <div class="content">
            <h1 class="is-uppercase has-text-centered has-text-primary">
              {{ texts.pageTitle }}
            </h1>
          </div>
        </div>
      </div>
      <div class="column is-12-fullhd">
        <div class="columns">
          <!-- <div class="column is-three-quarters products-title"> -->
            <div class="column  products-title">
            <div class="content">
              <p>
                {{ texts.firstRow }} <br /><br />
                {{ texts.secondRow }}
              </p>
              <ul>
                <li v-for="(li, index) in unorderedList" :key="index">
                  {{ li }}
                </li>
              </ul>
            </div>
          </div>

          <ProductCategories></ProductCategories>

        </div>
      </div>
      <div class="columns is-vcentered custom-vertical-space">
        <div class="column is-12"></div>
      </div>
      <div class="container second-container productsPaginationContainer" id="productsPaginationContainer">
        <PaginationContainer :products="products" :currentPage="currentPage" :productFound="texts.productFound"
          :allProducts="texts.all" />
      </div>
    </div>
    <div class="columns is-vcentered custom-vertical-space">
      <div class="column is-12"></div>
    </div>
    <app-footer></app-footer>
  </div>
</template>
<script>
import NavBar from "./Navbar.vue";
import AppFooter from "./AppFooter.vue";
import ProductCategories from "./ProductCategories.vue";
import boatTrailers from "../assets/boatTrailers.js";
import PaginationContainer from "./PaginationContainer";

export default {
  components: {
    NavBar: NavBar,
    AppFooter: AppFooter,
    PaginationContainer,
    ProductCategories: ProductCategories
  },
  data() {
    return {
      products: boatTrailers,
      currentPage: 1,
      // unorderedList: [],
      publicPath: process.env.BASE_URL,
      index: null,
      currentOffset: 0,
      dragging: false,
    };
  },
  created() {
    let url_string = window.location.href; //window.location.href
    let url = new URL(url_string);
    let setParameterInUrl = url.searchParams.get("set");
    if (this.getSetParameterFromUrl() == null) {
      this.currentPage = 1;
    } else {
      this.currentPage = Number(this.getSetParameterFromUrl());
    }
  },
  computed: {
    texts() {
      return this.$t("products.boatTrailer");
    },
    unorderedList() {
      return this.$t("products.boatTrailer.ul");
    },

    introTexts() {
      return this.$t("homePage");
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.setCurrentPage(to.query["set"]);
    next();
  },
  methods: {
    setCurrentPage(parameter) {
      let page = 1;
      if (parameter != null) {
        page = parseInt(parameter, 10);
      }
      this.currentPage = page;
    },
    getSetParameterFromUrl() {
      let url_string = window.location.href; //window.location.href
      let url = new URL(url_string);
      return url.searchParams.get("set");
    },
  },
  mounted() {
    this.$watch("$refs.carousel.currentOffset", function (new_value) {
      this.$data.currentOffset = -new_value;
      this.$data.dragging = this.$refs.carousel.dragging;
    });
  },
};
</script>

<style lang="scss" scoped>
.carousel-header {
  position: relative;
  z-index: 1000;
  background-color: white;
}

.card {
  border: 1px solid #266e79;
  border-bottom: 0px;
}

.card-content {
  text-align: center;
  padding: 0;

  h3 {
    padding-bottom: 10%;
    color: #00323d;
    border-bottom: 1px solid #266e79;
  }

  p {
    border-bottom: 1px solid #266e79;
    color: #00323d;
  }
}

.card .image img {
  padding: 25px;
}

.products-anchor:hover {
  img {
    transform-origin: center 58%;
    transition: 0.3s ease-out;
    transform: scale(1.02);
  }
}

.products-anchor {
  img {
    transition: 0.3s ease-out;
  }

  .image {
    padding: 8% 0;
  }

  .image img {
    min-width: 128px;
    max-width: 75%;
  }
}

.image p {
  position: absolute;
  right: 0;
  left: 0;
  text-align: center;
  color: #fff;
  z-index: 35;
  transition: 0.3s ease-out;
  text-transform: uppercase;
  font-size: 0.7em;
  max-width: 80%;
  margin: 0 auto;
  top: 50%;
  transform: translateY(-50%);
}

@include mobile {
  .image {
    display: flex;

    img {
      margin: 0 auto;
    }
  }

  .card-content h3 {
    padding-bottom: 3%;
  }
}

.price-container {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
}

.card-text.price {
  font-weight: 800;
}

.oldPriceContainer {
  text-decoration: line-through;
  color: red;
}

.oldPrice {
  border-bottom: none !important;
}

.newPrice {
  border-bottom: none !important;
}

.smallerPrice {
  color: red !important;
  font-size: 0.9rem !important;
}

.smallerPrice .oldPrice {
  text-decoration: line-through;
}
</style>